module.exports = __webpack_public_path__ + "img/logo-packeta.ea0d079e.png";